import Typography from '@mui/material/Typography';
import { PrimaryButton } from 'sharedComponents/Buttons';
import React, { useEffect, useState } from 'react';
import { BoltOutlined } from '@mui/icons-material';
import { useConnectContext } from 'features/Connect/features/Context/ConnectContextProvider';
import marketplaceSchoolsAPI from 'features/Connect/api/marketplaceSchoolsAPI';
import { ConnectModals } from 'features/Connect/utils/connectEnums';
import { QuickApplyButtonProps } from '../types';

export const QuickApplyButton: React.FC<QuickApplyButtonProps> = ({
  sx,
  buttonText = 'Quick Apply',
  showIcon = true,
  fontSize = '14px',
  disabled = false,
  onClick,
  isDistrictQuickApply = false,
  school,
  vacancy,
  dataTestId,
}) => {
  const { connectContextActions, districtSlugs } = useConnectContext();
  const [isLoadingDistrictSlug, setIsLoadingDistrictSlug] = useState(false);

  useEffect(() => {
    if (isDistrictQuickApply && school?.district?.nces_id) {
      const districtNcesId = school.district.nces_id;

      if (!(districtNcesId in districtSlugs)) {
        setIsLoadingDistrictSlug(true);
        marketplaceSchoolsAPI
          .getDistrictSlugByNcesId({ ncesId: districtNcesId })
          .then((slug) => {
            connectContextActions.setDistrictSlug(districtNcesId, slug);
          })
          .finally(() => {
            setIsLoadingDistrictSlug(false);
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDistrictQuickApply, school, districtSlugs]);

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (isDistrictQuickApply) {
      if (school) {
        connectContextActions.setSelectedSchool(school);
      }
      connectContextActions.setModalOpen(
        ConnectModals.QUICK_APPLY_DISTRICT_JOBBOARD_REDIRECT_MODAL,
        true
      );
    } else {
      if (!vacancy?.uuid || vacancy?.uuid === '0') {
        console.error('No vacancy ID found for link to formal application');
        return;
      }

      connectContextActions.setSelectedVacancyId(vacancy?.uuid);
      connectContextActions.setModalOpen(ConnectModals.READY_TO_CONNECT_MODAL, true);
    }
  };

  const isDisabled = disabled || (isDistrictQuickApply && isLoadingDistrictSlug);

  return (
    <PrimaryButton
      size="small"
      disabled={isDisabled}
      startIcon={showIcon && <BoltOutlined />}
      sx={{
        ...buttonStyles,
        ...sx,
      }}
      onClick={handleClick}
      dataTestId={dataTestId}
    >
      <Typography noWrap style={{ fontSize: fontSize, fontWeight: 600 }}>
        {buttonText}
      </Typography>
    </PrimaryButton>
  );
};
const buttonStyles = {
  backgroundColor: (theme) => theme.palette.purple.dark,
  borderRadius: '8px',
  height: '44px',
  padding: '14px',
  '& .MuiButton-startIcon': {
    margin: (theme) => theme.spacing(0),
  },
  '&:hover': {
    backgroundColor: (theme) => theme.palette.purple.darker,
  },
};
